import { updateHeaderRefreshToken } from './interceptors';
export var REQUEST_INTERCEPTORS_NAMES = {
  UPDATE_HEADER_REFRESH_TOKEN: '@request/headerRefreshToken'
};
export var RESPONSE_INTERCEPTORS_NAMES = {
  HANDLE_GENERAL_ERRORS: '@response/handleGeneralToken'
};
export var interceptors = {
  updateHeaderRefreshToken: updateHeaderRefreshToken
};